import React from 'react';
import { styled } from 'styled-components';

import { Paragraph } from '../theme/typography';

import TressymLogoSymbol from '../images/logo-symbol-yellow.svg';
import TinyDronesLogo from '../images/footer/logo-tinydrones.png';

const FooterContainer = styled.footer`
	background-color: ${(props) => props.theme.colors.neutral1};
`;

const TressymDataBlockFirst = styled.div`
	display: flex;
	justify-content: center;
	padding: 4rem 0 2rem;
`;

const TressymDataBlock = styled(TressymDataBlockFirst)`
    border-top: none;
	padding-top: 0;
	margin-top: 0;
	padding-bottom: 4rem;
`;

const TressymLogo = styled.img`
	color: ${(props) => props.theme.colors.yellow6};
	width: 4rem;
`;

const TressymLogoWordmark = styled.h3`
	${(props) => props.theme.typography.headingXS};
	color: ${(props) => props.theme.colors.yellow6};
	margin-top: 1rem;
	text-transform: uppercase;
`;

const FlexParagraph = styled(Paragraph)`
	margin-top: 0.5rem;
	text-wrap: balance;
`;

const DataBlockContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 24rem;
	text-align: center;
`;

const ResellerLogo = styled.img`
`;

export const FooterSection = () => (
	<FooterContainer>
		<TressymDataBlockFirst>
			<DataBlockContent>
				<TressymLogo src={TressymLogoSymbol} alt="Tressym logo" />
				<TressymLogoWordmark>Tressym Drone Labs</TressymLogoWordmark>
				<FlexParagraph>Csaba "Ed" Schreiner<br/>sole proprietor</FlexParagraph>
				<FlexParagraph>EU VAT: HU91218096<br/>Mester u. 85/B 405.<br/>1095 Budapest<br/>Hungary</FlexParagraph>
			</DataBlockContent>
		</TressymDataBlockFirst>
		<TressymDataBlock>
			<DataBlockContent>
				<TressymLogoWordmark>Partner leagues</TressymLogoWordmark>
				<FlexParagraph>These racing communities are our official partners.</FlexParagraph>
				<a href="https://tinydrones.eu" target="_blank" rel="noopener noreferrer"><ResellerLogo src={TinyDronesLogo} alt="Tiny Drones logo" /></a>
			</DataBlockContent>
		</TressymDataBlock>
	</FooterContainer>
);